// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"Terms_privacyPolicy__YFqc5"};